import {all, call, put, takeEvery} from "redux-saga/effects";
import {
  ImagesActionTypes,
  fetchError,
  fetchSuccess,
  deleteError,
  deleteSuccess,
  createError,
  createSuccess, updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from "@actions/image";
import imageApi from "@api/image";
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(imageApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(imageApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err));
  }
}


/**
 * This function is called after an image is created or updated successfully and will update tags
 * @param image_id
 * @param payload
 */
function* updateImageTags(image_id: string, payload) {
  try {
    const params = {id: image_id};
    const {tags} = payload;
    const {new_tags, deleted_tags} = tags;
    if (new_tags.length > 0) {
      yield call(imageApi.addTags, {
        params,
        payload: {
          tag_ids: new_tags
        }
      });
    }
    if (deleted_tags.length > 0) {
      yield call(imageApi.deleteTags, {
        params,
        payload: {
          tag_ids: deleted_tags
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}

function* handleCreate({payload}: ReduxAction) {
  try {
    const response = yield call(imageApi.create, payload);
    const image = response.data;
    yield updateImageTags(image.id, payload.payload);
    payload.onSuccessCallback && payload.onSuccessCallback(image);
    yield put(createSuccess(response.data))
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const response = yield call(imageApi.update, payload);
    const image = response.data;
    yield updateImageTags(image.id, payload.payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(image))
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const response = yield call(imageApi.getItem, payload);
    const image = response.data;
    yield put(fetchItemSuccess(image))
  } catch (err) {
    yield put(fetchItemError(err))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* imagesSaga() {
  yield all([
    yield takeEvery(ImagesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(ImagesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(ImagesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(ImagesActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(ImagesActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  
  ]);
}

export default imagesSaga;
